export class MathExt {

    static sign(x: number): number {
        return 1.0 / x > 0.0 ? 1.0 : -1.0;
    }

    static parametricBlend(t: number, a: number = 2.0): number {
        const sqt = t * t;
        return sqt / (a * (sqt - t) + 1.0);
    }

}